import { Action } from '@ngrx/store';
import { Event, Category } from './events.models';

export enum EventsActionTypes {
  LOAD_EVENTS = '[EventsAction] Load events',
  LOAD_EVENTS_FAILED = '[EventsAction] Load events failed',
  LOAD_EVENTS_SUCCESS = '[EventsAction] Load events success',
  LOAD_CATEGORIES = '[EventsAction] Load categories',
  LOAD_CATEGORIES_FAILED = '[EventsAction] Load categories failed',
  LOAD_CATEGORIES_SUCCESS = '[EventsAction] Load categories success',
  SAVE_EVENT = '[EventsAction] Save event',
  SAVE_EVENT_FAILED = '[EventsAction] Save event failed',
  SAVE_EVENT_SUCCESS = '[EventsAction] Save event success',
  SELECT_EVENT = '[EventsAction] Select event',
  DELETE_EVENT = '[EventsAction] Delete event',
  DELETE_EVENT_FAILED = '[EventsAction] Delete event failed',
  DELETE_EVENT_SUCCESS = '[EventsAction] Delete event success',
  UPDATE_EVENT = '[EventsAction] Update event',
  UPDATE_EVENT_FAILED = '[EventsAction] Update event failed',
  UPDATE_EVENT_SUCCESS = '[EventsAction] Update event success'
}

export class EventsActionLoadEvents implements Action {
  readonly type = EventsActionTypes.LOAD_EVENTS;
}

export class EventsActionLoadEventsFailed implements Action {
  readonly type = EventsActionTypes.LOAD_EVENTS_FAILED;
}

export class EventsActionLoadEventsSuccess implements Action {
  readonly type = EventsActionTypes.LOAD_EVENTS_SUCCESS;

  constructor(public payload: Array<Event>) {}
}

export class EventsActionLoadCategories implements Action {
  readonly type = EventsActionTypes.LOAD_CATEGORIES;
}

export class EventsActionLoadCategoriesFailed implements Action {
  readonly type = EventsActionTypes.LOAD_CATEGORIES_FAILED;
}

export class EventsActionLoadCategoriesSuccess implements Action {
  readonly type = EventsActionTypes.LOAD_CATEGORIES_SUCCESS;

  constructor(public payload: Array<Category>) {}
}

export class EventsActionSaveEventFailed implements Action {
  readonly type = EventsActionTypes.SAVE_EVENT_FAILED;
}

export class EventsActionSaveEventSuccess implements Action {
  readonly type = EventsActionTypes.SAVE_EVENT_SUCCESS;
}

export class EventsActionSaveEvent implements Action {
  readonly type = EventsActionTypes.SAVE_EVENT;

  constructor(
    public payload: {
      categoryUuid: string;
      datetime: string;
      value: string;
      reminder: string;
    }
  ) {}
}

export class EventsActionSelectEvent implements Action {
  readonly type = EventsActionTypes.SELECT_EVENT;

  constructor(public payload: Event) {}
}

export class EventsActionDeleteEvent implements Action {
  readonly type = EventsActionTypes.DELETE_EVENT;

  constructor(public payload: string) {}
}

export class EventsActionDeleteEventFailed implements Action {
  readonly type = EventsActionTypes.DELETE_EVENT_FAILED;
}

export class EventsActionDeleteEventSuccess implements Action {
  readonly type = EventsActionTypes.DELETE_EVENT_SUCCESS;
}

export class EventsActionUpdateEvent implements Action {
  readonly type = EventsActionTypes.UPDATE_EVENT;

  constructor(
    public payload: {
      eventUuid: string;
      datetime: string;
      reminder: string;
      value: string;
      attended: boolean;
    }
  ) {}
}

export class EventsActionUpdateEventFailed implements Action {
  readonly type = EventsActionTypes.UPDATE_EVENT_FAILED;
}

export class EventsActionUpdateEventSuccess implements Action {
  readonly type = EventsActionTypes.UPDATE_EVENT_SUCCESS;
}

export type EventsActions =
  | EventsActionLoadEvents
  | EventsActionLoadEventsFailed
  | EventsActionLoadEventsSuccess
  | EventsActionLoadCategories
  | EventsActionLoadCategoriesFailed
  | EventsActionLoadCategoriesSuccess
  | EventsActionSaveEvent
  | EventsActionSaveEventFailed
  | EventsActionSaveEventSuccess
  | EventsActionSelectEvent
  | EventsActionDeleteEvent
  | EventsActionDeleteEventFailed
  | EventsActionDeleteEventSuccess
  | EventsActionUpdateEvent
  | EventsActionUpdateEventFailed
  | EventsActionUpdateEventSuccess;
